import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ROLE_LABELS } from '@wit-support/admin-contracts';
import { Badge } from '@wit-support/ui';
import { cn } from './lib/cn.js';
import { capitalize } from './lib/capitalize.js';
/**
 * Admin role chip. Label from `ROLE_LABELS` (support roles keep their English
 * names, `marketing` reads «Маркетинг»); colours come from
 * `--color-role-<role>-{bg,fg}` in `@wit-support/ui/theme.css`.
 */
export const RoleBadge = React.forwardRef(({ role, size = 'md', className }, ref) => {
    const style = {
        backgroundColor: `var(--color-role-${role}-bg)`,
        color: `var(--color-role-${role}-fg)`,
    };
    return (_jsx(Badge, { ref: ref, size: size, variant: "neutral", className: cn('border-transparent', className), style: style, children: ROLE_LABELS[role] ?? capitalize(role) }));
});
RoleBadge.displayName = 'RoleBadge';
//# sourceMappingURL=role-badge.js.map